export let showWindowHref = () => {
    var sHref = window.location.href;
    if (sHref.indexOf('?') == -1) {
        return;
    } else {
        var args = sHref.split('?');
        var arr = args[1].split('&');
        var obj = {};
        for (var i = 0; i < arr.length; i++) {
            var arg = arr[i].split('=');
            obj[arg[0]] = arg[1];
        }
        return obj;
    }
}


// WEBPACK FOOTER //
// ./src/plugin/g_methods.js